import { MemoryRouter, Route, Routes } from 'react-router'

import { AdditionalRiskData } from '../Pages/AdditionalRiskData'
import { Confirmation } from '../Pages/Confirmation'
import { DataToSimulate } from '../Pages/DataToSimulate'
import { Formalization } from '../Pages/Formalization'
import { OwnerData } from '../Pages/OwnerData'
import { SimulationResult } from '../Pages/SimulationResult'
import { SummaryConditions } from '../Pages/SummaryConditions'
import { ROUTES } from '../constants/routes'
import { BaseLayout } from '../layout/BaseLayout'

export const Router = () => (
  <MemoryRouter
    initialEntries={[...Object.values(ROUTES), { pathname: '/three' }]}
    initialIndex={0}
  >
    <Routes>
      <Route path={ROUTES.base} element={<BaseLayout />}>
        <Route path={ROUTES.base} index element={<DataToSimulate />} />
        <Route path={ROUTES.simulationResult} element={<SimulationResult />} />
        <Route path={ROUTES.ownerData} element={<OwnerData />} />
        <Route
          path={ROUTES.additionalRiskData}
          element={<AdditionalRiskData />}
        />
        <Route
          path={ROUTES.summaryConditions}
          element={<SummaryConditions />}
        />
        <Route path={ROUTES.confirmation} element={<Confirmation />} />
        <Route path={ROUTES.formalization} element={<Formalization />} />
      </Route>
    </Routes>
  </MemoryRouter>
)
